import Button from "../Button/Button";



type OrderNavigationProps = {
  onNext: () => void;
  onBack: () => void;
  isOrderStep?: boolean;
  hideBackButton?: boolean;
  nextLabel?: string;
  backLabel?: string;
  onCancel?: () => void;
  showCancelButton?: boolean;
};

const OrderNavigation = ({
  onNext,
  onBack,
  isOrderStep = false,
  hideBackButton = false,
  nextLabel,
  backLabel,
  onCancel,
  showCancelButton = false,
}: OrderNavigationProps) => {
  const resolvedNextLabel = nextLabel ?? (isOrderStep ? "Concluir pedido" : "Continuar");
  const resolvedBackLabel = backLabel ?? "Voltar";

  return (
    <div className={`bg-white border p-4 rounded shadow`}>
      <Button
        className="mb-2 w-full py-2"
        onClick={onNext}
      >
        {resolvedNextLabel}
      </Button>

      {!hideBackButton && (
        <Button variant="secondary"
          className="w-full py-2"
          onClick={onBack}
        >
          {resolvedBackLabel}
        </Button>
      )}

      {showCancelButton && onCancel && (
        <Button variant="secondary"
          className="w-full py-2"
          onClick={onCancel}
        >
          Cancelar
        </Button>
      )}
    </div>
  );
}

export default OrderNavigation;
